import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiNotepad } from 'react-icons/pi';
import { IArtistMutationForm } from 'services/artists/types';

const ArtistRemarks = () => {
  const {
    values,
    status,
  }: IFormikContextType<IArtistMutationForm> =
    useFormikContext<IArtistMutationForm>();
  const { t } = useTranslation();
  return (
    <Container className=' self-start max-w-[500px]'>
      <Container.Header
        title={
          <>
            <PiNotepad /> {t('artist.remarks.header')}
          </>
        }
      />
      <Container.Content>
        {status?.displayMode ? (
          values.remarks?.trim().length ? (
            values.remarks
          ) : (
            t('artist.remarks.no-remarks')
          )
        ) : (
          <FormInput.Field name='remarks' label={t('input.label.remarks')} />
        )}
      </Container.Content>
    </Container>
  );
};

export default ArtistRemarks;
